import { render } from "./DefaultLayout.vue?vue&type=template&id=3a1c624c&ts=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"

import "./DefaultLayout.vue?vue&type=style&index=0&id=3a1c624c&lang=scss"

import exportComponent from "/codebuild/output/src4075662509/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__